import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { getCommonCountryCodes } from './utils/countryFlags';
import { preloadFlags } from './utils/flagCache';
import * as serviceWorkerRegistration from './utils/serviceWorkerRegistration';

// Preload commonly used flags for better performance
const commonFlags = getCommonCountryCodes();
preloadFlags(commonFlags);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline support
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ App is ready for offline use');
  },
  onUpdate: (registration) => {
    console.log('🔄 New version available - updating automatically');
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      // Auto-reload after service worker is ready
      registration.waiting.addEventListener('statechange', (e) => {
        if ((e.target as ServiceWorker).state === 'activated') {
          globalThis.location.reload();
        }
      });
    }
  },
  onError: (error) => {
    console.error('❌ Service worker registration failed:', error);
  }
});
